import { Box, Icon, Paragraph } from '@zillow/constellation-10';
import { IconSmartphoneFilled } from '@zillow/constellation-icons';

import { containerRecipe } from '../../UploadDropzone/styles';

import type { ReactNode } from 'react';

/**
 * Empty-state counterpart to the photo dropzone, sized to match it. The panel itself is not
 * clickable — `children` holds the button that opens the modal, since the dropzone beside it
 * owns whole-area clicks as a drop target.
 */
const PhoneUploadPanel = ({ isDisabled = false, children }: { isDisabled?: boolean; children: ReactNode }) => (
  <Box
    css={{
      ...containerRecipe.raw({
        isContainerSizeFixed: false,
        isSmallDropzone: false,
        isDisabled,
        isDragAccept: false,
        isDragReject: false,
      }),
      // The recipe assumes a clickable dropzone; only the button inside this panel is interactive.
      cursor: isDisabled ? 'not-allowed' : 'default',
    }}
  >
    <Icon render={<IconSmartphoneFilled />} size="lg" />
    <Paragraph css={{ marginBlock: 'default' }}>Add photos from your phone</Paragraph>
    {children}
  </Box>
);

export default PhoneUploadPanel;
